export class ClienteOptions {
    canImportar: boolean;
    canImportarUnidadeNegocio: boolean;
    canImprimirListagem: boolean;
    canImportErp_v1: boolean;
    canImportErp: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canImprimirListagem ||
                this.canImportErp_v1 ||
                this.canImportErp ||
                this.hasImportarOptions();
    }

    /** Verifica se possui alguma opção de importar */
    hasImportarOptions(): boolean {
        return this.canImportar || this.canImportarUnidadeNegocio;
    }
}
